export default {
  active: "Ativa",
  cancelled: "Cancelada",
  cancelled_order: "Pedido Cancelado",
  error: "Rejeição",
  open: "Aberta"
};



// WEBPACK FOOTER //
// ./src/core/enum/sale-status.enum.js